import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ModalBody } from 'react-bootstrap';

import ModalFotterYesNoButtonComponent from '../../molecules/ModalFotterYesNoButtonComponent';

class CopyConfirmModal extends React.Component {
  static get propTypes() {
    return {
      targetId: PropTypes.string,
      children: PropTypes.string,
      show: PropTypes.bool,
      onYesClick: PropTypes.func,
      onNoClick: PropTypes.func,
    };
  }

  render() {
    return (
      <Modal show={this.props.show}>
        <ModalBody>
          <p className="text-center">
            選択されたロールをコピーしてよろしいですか？
          </p>
        </ModalBody>
        <ModalFotterYesNoButtonComponent
          onNoClick={this.props.onNoClick}
          onYesClick={this.props.onYesClick}
        />
      </Modal>
    );
  }
}

export default CopyConfirmModal;
